namespace $ {

	export type $shm_hitalama_map_history_storage_writer_cursor = {
		sequence: number, page: number, count: number, bytes: number, day?: number
	}

	export class $shm_hitalama_map_history_storage_writer extends $giper_baza_entity.with({
		Cursor: $giper_baza_atom_dict,
		Recent: $giper_baza_list_dict,
		Recent_compact: $giper_baza_atom_dict,
	}) {

		cursor( next?: $shm_hitalama_map_history_storage_writer_cursor ) {
			this.keys()
			let cursor = this.Cursor()
			if( !cursor && next !== undefined ) {
				this.Cursor( null )
				cursor = this.Cursor()
			}
			return cursor?.val( next ) as typeof next ?? {
				sequence: 0,
				page: 0,
				count: 0,
				bytes: 0,
			}
		}

		/** Pure allocation also used while preparing an all-or-nothing migration. */
		cursor_plan( current: $shm_hitalama_map_history_storage_writer_cursor, bytes: number, count_limit: number, byte_limit: number, time?: number ) {
			if( [current.sequence, current.page, current.count, current.bytes, bytes].some( value=> !Number.isSafeInteger(value) || value < 0 )
				|| !Number.isSafeInteger(count_limit) || count_limit < 1
				|| !Number.isSafeInteger(byte_limit) || byte_limit < 1
				|| current.day !== undefined && !Number.isSafeInteger(current.day)
				|| time !== undefined && !Number.isFinite(time) ) throw new Error( 'Некорректная граница страницы истории' )
			const day = time === undefined ? current.day : Math.floor( time / 86_400_000 )
			if( day !== undefined && !Number.isSafeInteger(day) ) throw new Error( 'Некорректный день истории' )
			// Never append a dated event to an unknown legacy page or another day.
			// Late delivery starts a new bounded page; existing page links stay valid.
			const rollover = current.count > 0 && ( day !== current.day
				|| current.count >= count_limit || current.bytes + bytes > byte_limit )
			const next: $shm_hitalama_map_history_storage_writer_cursor = {
				sequence: current.sequence + 1,
				page: current.page + ( rollover ? 1 : 0 ),
				count: rollover ? 1 : current.count + 1,
				bytes: rollover ? bytes : current.bytes + bytes,
				... day !== undefined ? { day } : {},
			}
			if( [next.sequence, next.page, next.count, next.bytes].some( value=> !Number.isSafeInteger(value) ) ) {
				throw new Error( 'Переполнение страницы истории' )
			}
			return next
		}

		allocate( bytes: number, count_limit: number, byte_limit: number, time?: number ) {
			const next = this.cursor_plan( this.cursor()!, bytes, count_limit, byte_limit, time )
			this.cursor( next )
			return { page: next.page }
		}

		recent( next?: readonly Pick< $shm_hitalama_map_history_summary, 'e' | 'i' >[] ): readonly Pick< $shm_hitalama_map_history_summary, 'e' | 'i' >[] {
			this.keys()
			if( next !== undefined ) {
				const entries = next.slice( -64 ).map( ({ e, i })=> ({ e, i }) )
				const packed = { v: 1, entries }
				if( $mol_charset_encode( JSON.stringify( packed ) ).byteLength > 48000 ) throw new Error( 'Идентификаторы последних событий истории слишком велики' )
				this.Recent_compact( null )!.val( packed )
				return entries
			}
			const atom = this.Recent_compact()
			if( atom ) {
				const packed = atom.val()
				if( !packed || packed.v !== 1 || !Array.isArray( packed.entries ) ) return []
				return packed.entries.filter( entry=> entry && typeof entry.e === 'string' && typeof entry.i === 'string' ).slice( -64 )
			}
			// Old writers stored full summaries here. Read them for compatibility,
			// but never copy their previews into the new bounded deduplication atom.
			return ( this.Recent()?.items() as readonly Pick< $shm_hitalama_map_history_summary, 'e' | 'i' >[] ?? [] )
				.filter( entry=> entry && typeof entry.e === 'string' && typeof entry.i === 'string' )
				.slice( -64 ).map( ({ e, i })=> ({ e, i }) )
		}

	}

}
